import axios from 'axios';

export const REQUEST_METHOD = Object.freeze({
    DELETE: "delete",
    GET : "get",
    POST: "post",
    PUT: "put",
    UPDATE: "update"
});

export default class api {
    
    request(path, token, method = REQUEST_METHOD.GET, data = null) {
        return new Promise((resolve, reject) => {
            let requestConfig = {
                baseURL: process.env.REACT_APP_PORTAL_API_URI,
                url: path,
                method: method,
                //headers: {
                //    "Authorization": `Bearer ${token}`
                //}
            };

            if(token) {
                requestConfig.headers = {"Authorization": `Bearer ${token}`};
            }

            if(data !== null) {
                requestConfig.data = data;
            }
            console.log("api.Promise - request config: ", requestConfig);
            
            axios(requestConfig)
            .then(resp => {
                resolve(resp.data);
            })
            .catch(err => {
                reject(err);
            });
        });
    }

    /**
     * Sends a raw binary body (a Blob) rather than JSON.
     *
     * Used for raw surface captures, which are gzipped in the browser and stored by the API
     * exactly as sent. Going through request() would let axios serialize the Blob and corrupt
     * it, so the content type is set explicitly and the body passed straight through.
     */
    requestBinary(path, token, method = REQUEST_METHOD.POST, body = null, contentType = "application/octet-stream") {
        return new Promise((resolve, reject) => {
            let requestConfig = {
                baseURL: process.env.REACT_APP_PORTAL_API_URI,
                url: path,
                method: method,
                data: body,
                headers: { "Content-Type": contentType },
                // A capture can be tens of MB before compression; the defaults are too small.
                maxBodyLength: Infinity,
                maxContentLength: Infinity,
            };

            if(token) {
                requestConfig.headers["Authorization"] = `Bearer ${token}`;
            }

            axios(requestConfig)
            .then(resp => {
                resolve(resp.data);
            })
            .catch(err => {
                reject(err);
            });
        });
    }
}